import React from 'react';

export default function TextIcon({ svg, text,textColor }) {
    return (
        <div className='collapseCardIconBox'>
            <div className='svg'>
                {svg}
            </div>
            <div className='text' style={{color: textColor}}>
                {text}
            </div>
        </div>
    )
}